import type { IconSvgObject } from './types';

const PlayListIcon: IconSvgObject = [
  ["path", { d: "M3 7H21", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 2.5L14 7", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 2.5L7 7", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M10 15.6783V12.3217C10 11.5326 10.8712 11.0544 11.5369 11.478L14.1742 13.1563C14.7917 13.5493 14.7917 14.4507 14.1742 14.8437L11.5369 16.522C10.8712 16.9456 10 16.4674 10 15.6783Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default PlayListIcon;
